import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useStoreState, useStoreActions } from 'easy-peasy'
import { Form, Alert } from 'reactstrap'
import inputs from '../components/form'
import BtnAction from '../components/form/BtnAction'
import Title from '../components/common/Title'
import FootNote from '../components/common/FootNote'
import Text from '../utils/Text'
import media from '../utils/media'
import Paragraph from '../components/common/Paragraph'
import CheckCircleGreen from '../components/icons/CheckCircleGreen'

const Container = styled.div`
  text-align: center;
  .form-title {
    margin-top: 60px;
  }
  .form-subtitle {
    max-width: 681px;
    margin: 0 auto;
  }
  .styled-btn-action {
    width: 100%;
  }
  .text-util a {
    text-decoration: underline !important;
    color: #414141 !important;
    &:hover {
      color: #414141 !important;
    }
  }
  #generalError {
    margin: -13px auto;
    max-width: 443px;
    border: none;
  }
  .form-footer {
    padding: 0 10px;
  }
  .form-info {
    margin-bottom: 0;
    margin-top: 14px;
    text-align: left;
    opacity: 0.7;
    font-size: 12px;
  }

  ${media.mobileL`
    .form-title {
      margin-top: 0;
      margin-bottom: 25px;
      p {
        font-size: 23px;
      }
    }
    .form-subtitle p {
      font-size: 16px;
      line-height: 23px;
      strong {
        display: inline;
      }
    }
  `}
`

const BtnWrapper = styled.div`
  text-align: center;
  margin-bottom: 76px;
  margin-top: 60px;
  ${media.tabletS`
    margin-bottom: 58px;
  `}
`

const Button = styled.a`
  height: 50px;
  width: ${props => (props.btnWidth ? `${props.btnWidth}` : '262px')};
  background-color: ${props => props.btnBg} !important;
  color: ${props => props.btnColor} !important;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  letter-spacing: 1.85px;
  line-height: 21px;
  white-space: nowrap;
  vertical-align: middle;
  padding: 15px;
  border: none;
  text-align: center;
  touch-action: manipulation;
  cursor: pointer;
  &:hover {
    text-decoration: none !important;
  }
  &:focus {
    outline: none !important;
    box-shadow: none !important;
  }
  &:active {
    opacity: 0.7;
  }
  ${media.mobileL`
    width: ${props => props.btnWidthMobile && props.btnWidthMobile};
  `}
`

const ContainerForm = styled.div`
  width: 100%;
  max-width: 280px;
  margin: 0 auto;
`

export default function FormPage({ step }) {
  const [
    {
      title,
      text,
      btn,
      popup,
      footnote,
      info,
      form: formData,
      formInfo,
      validContentBtn,
    },
    generalError,
    validationErrors,
    filledFields,
    validated,
    locale,
  ] = useStoreState(state => [
    state.steps.pages[step],
    state.form.generalError,
    state.form.validationErrors,
    state.form.filledFields,
    state.form.validated,
    state.locale.locale,
  ])
  const [submit] = useStoreActions(actions => [actions.form.submit])

  const LIC_URL = `${process.env.REACT_APP_LIC_URL}login`

  const LOCALE = {
    es: locale === 'es-es',
  }
  const [disableBtn, setDisableBtn] = useState(true)

  useEffect(() => {
    if (Object.keys(validationErrors).length === 0) {
      if (filledFields && filledFields.emai) {
        setDisableBtn(false)
      } else {
        setDisableBtn(true)
      }
    } else {
      setDisableBtn(true)
    }
  }, [filledFields, validationErrors, btn])

  const renderEmailMessage = () => (
    <>
      <CheckCircleGreen width="82" height="82" />
      <Paragraph paragraph={popup.title} fontSize={popup.titleSize} />
      <Paragraph paragraph={popup.text} fontSize={popup.textSize} />
    </>
  )

  const renderEmailValidatedUser = () => (
    <>
      <CheckCircleGreen width="82" height="82" />
      <Paragraph
        paragraph={popup.titleValidated}
        fontSize={popup.titleSize}
      />
      <Paragraph
        paragraph={popup.textValidated}
        fontSize={popup.textSize}
      />
      {LOCALE.es && validContentBtn && (
        <>
          <BtnWrapper>
            <Button
              href={LIC_URL}
              btnBg={validContentBtn.btnBg}
              btnColor={validContentBtn.btnColor}
              btnWidth={validContentBtn.btnWidth}
            >
              <Text id={validContentBtn.btnText} />
            </Button>
          </BtnWrapper>
        </>
      )}
    </>
  )

  return (
    <Container className="form-component" locale={locale}>
      {/* <PopUp config={popup} error={!!generalError} /> */}
      {validated === false && renderEmailMessage()}
      {validated === true && renderEmailValidatedUser()}
      {title && (
        <Title
          title={title && title.text}
          titleSize={title.titleSize}
          titleColor={title.titleColor}
          marginBTitle={title.marginBTitle}
          classN="form-title"
        />
      )}
      {validated === null && text && (
        <Title
          title={text.text}
          titleSize={text.titleSize}
          titleColor={text.titleColor}
          marginBTitle={text.marginBTitle}
          lineHeight={text.lineHeight}
          titleFamily={text.titleFamily}
          classN="form-subtitle"
        />
      )}
      {validated === null && (
        <ContainerForm>
          <Form
            onSubmit={ev => {
              ev.preventDefault()
              submit()
            }}
          >
            {/* {generalError &&
            generalError !==
              'server.errors.alreadyRegistered.message' && (
              <Alert id="generalError" fade={false} color="danger">
                <Text id={generalError} />
              </Alert>
            )} */}
            {formData.map(({ type, name, error, ...rest }) => {
              const InputComp = inputs[type]
              /* eslint-disable-next-line no-param-reassign */
              if (name === 'country') rest.value = locale
              return (
                <div key={`input-${name}`}>
                  <InputComp
                    name={name}
                    error={error}
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...rest}
                  />
                  {type === 'Email' &&
                    generalError &&
                    generalError ===
                      'server.errors.alreadyRegistered.message' && (
                      <Alert
                        id="generalError"
                        fade={false}
                        color="danger"
                      >
                        <Text id={generalError} />
                      </Alert>
                    )}
                </div>
              )
            })}
            {formInfo && (
              <FootNote footnote={formInfo} className="form-info" />
            )}
            <BtnAction
              id="submit"
              btn={btn}
              disabled={btn.disabled && disableBtn}
            />
          </Form>
          {info && (
            <FootNote footnote={info} className="form-footer" />
          )}
          {footnote && (
            <FootNote footnote={footnote} className="form-footer" />
          )}
        </ContainerForm>
      )}
    </Container>
  )
}
